import { ReplayIcon } from '@weblite/icons'
import { IconButton, Stack, SxProps, Typography } from '@mui/material'
import { t } from '$i18n'
import { GroupIcon } from '$common/icons'

interface Props {
  Icon?: ({ ...props }) => JSX.Element
  text?: string
  sx?: SxProps
  showIcon?: boolean
  onRetry?: () => void
}

export function ErrorStateList({
  // eslint-disable-next-line react/jsx-props-no-spreading
  Icon = ({ ...props }) => <GroupIcon {...props} />,
  text = t('errorState.default'),
  sx,
  showIcon = true,
  onRetry,
}: Props) {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{
        height: '100%',
        ...sx,
      }}
    >
      {onRetry ? (
        <IconButton onClick={onRetry}>
          <ReplayIcon
            sx={{ color: 'error500', width: '24px', height: '24px' }}
          />
        </IconButton>
      ) : (
        showIcon && (
          <Icon sx={{ width: '68px', height: '52px', color: 'error500' }} />
        )
      )}
      <Typography variant="body2" color="error500">
        {text}
      </Typography>
    </Stack>
  )
}
